import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatTableExporterModule} from 'mat-table-exporter';
import {MatTableFilterModule} from 'mat-table-filter';
import {CdkTableExporterModule} from 'cdk-table-exporter';
import {
	MatAutocompleteModule,
	MatButtonModule,
	MatButtonToggleModule,
	MatCardModule,
	MatCheckboxModule,
	MatChipsModule,
	MatDatepickerModule,
	MatDialogModule,
	MatExpansionModule,
	MatGridListModule,
	MatIconModule,
	MatInputModule,
	MatListModule,
	MatMenuModule,
	MatNativeDateModule,
	MatPaginatorModule,
	MatProgressBarModule,
	MatProgressSpinnerModule,
	MatRadioModule,
	MatRippleModule,
	MatSelectModule,
	MatSidenavModule,
	MatSliderModule,
	MatSlideToggleModule,
	MatSnackBarModule,
	MatSortModule,
	MatTableModule,
	MatTabsModule,
	MatToolbarModule,
	MatTooltipModule,
	MatStepperModule,
	MatTreeModule,
	MatBadgeModule,
	MatBottomSheetModule,
	MatDividerModule,
	MatFormFieldModule

} from '@angular/material';
import {A11yModule} from '@angular/cdk/a11y';
import {BidiModule} from '@angular/cdk/bidi';
import {ObserversModule} from '@angular/cdk/observers';
import {OverlayModule} from '@angular/cdk/overlay';
import {PlatformModule} from '@angular/cdk/platform';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollDispatchModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";

const MODULES = [
	CdkTreeModule,
	RouterModule,
	FlexLayoutModule,
	MatAutocompleteModule,
	MatButtonModule,
	MatButtonToggleModule,
	MatCardModule,
	MatCheckboxModule,
	MatChipsModule,
	MatDatepickerModule,
	MatDialogModule,
	MatExpansionModule,
	MatGridListModule,
	MatIconModule,
	MatInputModule,
	MatListModule,
	MatMenuModule,
	MatNativeDateModule,
	MatPaginatorModule,
	MatProgressBarModule,
	MatProgressSpinnerModule,
	MatRadioModule,
	MatRippleModule,
	MatSelectModule,
	MatSidenavModule,
	MatSliderModule,
	MatSlideToggleModule,
	MatSnackBarModule,
	MatSortModule,
	MatTableModule,
	MatTabsModule,
	MatToolbarModule,
	MatTooltipModule,
	MatStepperModule,
	MatTreeModule,
	MatBadgeModule,
	MatBottomSheetModule,
	MatDividerModule,
	MatFormFieldModule,
	A11yModule,
	BidiModule,
	ObserversModule,
	OverlayModule,
	PlatformModule,
	PortalModule,
	ScrollDispatchModule,
	CdkStepperModule,
	CdkTableModule,
	CdkTreeModule,
	DragDropModule,
	MatTableExporterModule,
	MatTableFilterModule,
	CdkTableExporterModule,
	NgxMatSelectSearchModule,
];

@NgModule({
	imports: [
		CommonModule,
		MODULES
	],
	exports: [
		MODULES
	]
})
export class MaterialModule {
}
